import { types } from './actions';

const initialState = {
  isOpen: false,
  quoteId: null,
  activeTabIndex: 0,
};

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case types.OPEN_NEST_MODULE:
      return {
        ...state,
        isOpen: true,
        quoteId: payload.quoteId,
      };
    case types.CLOSE_NEST_MODULE:
      return {
        ...state,
        isOpen: false,
        quoteId: null,
        activeTabIndex: 0,
      };
    case types.SET_ACTIVE_TAB_INDEX:
      return {
        ...state,
        activeTabIndex: payload.activeTabIndex,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.modals.nestModule;

export const isOpen = (state) => getScope(state).isOpen;

export const getQuoteId = (state) => getScope(state).quoteId;

export const getActiveTabIndex = (state) => getScope(state).activeTabIndex;
